if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector('.product-images') ? this.productWrapper.querySelector('.product-images') : this.productWrapper.querySelector('.product-quick-images');
        this.thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }
      this.addEventListener('mousedown', (e) => {
        if (e.target.tagName === 'LABEL') {
          const scrollY = window.scrollY;
          requestAnimationFrame(() => window.scrollTo({ top: scrollY, behavior: 'instant' }));
        }
      });
      this.expectedPriceMarkup = {};
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.setupPriceFormatLock();
      this.addEventListener('change', this.onVariantChange);
    }

    disconnectedCallback() {
      if (this.priceLockObserver) {
        this.priceLockObserver.disconnect();
        this.priceLockObserver = null;
      }
      if (this.priceFormatGuardInterval) {
        window.clearInterval(this.priceFormatGuardInterval);
        this.priceFormatGuardInterval = null;
      }
      if (this.priceNormalizeRaf) {
        cancelAnimationFrame(this.priceNormalizeRaf);
        this.priceNormalizeRaf = null;
      }
    }

    onVariantChange() {
      this.updateOptions();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();

      this.renderVariantInfo();

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      const span = this.querySelector(`#SelectedVariant-${this.dataset.section}`);
      if (!span) return;
      this.currentVariant = {
        id: parseInt(span.dataset.variantId, 10) || null,
        available: span.dataset.available === 'true',
        featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null,
        price_formatted: span.dataset.priceFormatted || '',
        price_cents: parseInt(span.dataset.priceCents, 10) || 0
      };
    }

    formatMoneyNoCurrency(cents) {
      const format = window.theme?.settings?.money_format || "${{amount}}";
      if (typeof formatMoney === 'function') {
        return formatMoney(cents, format);
      }
      return '';
    }

    cacheExpectedPriceMarkup() {
      const mainPrice = document.getElementById(`price-${this.dataset.section}`);
      const stickyPrice = document.getElementById(`price-${this.dataset.section}--sticky`);
      if (mainPrice) this.expectedPriceMarkup[mainPrice.id] = mainPrice.innerHTML;
      if (stickyPrice) this.expectedPriceMarkup[stickyPrice.id] = stickyPrice.innerHTML;
    }

    scheduleNormalizePrices() {
      if (this.priceNormalizeRaf) return;
      this.priceNormalizeRaf = requestAnimationFrame(() => {
        this.priceNormalizeRaf = null;
        this.normalizePriceContainers();
      });
    }

    getCurrentPriceCents() {
      const variantCents = parseInt(this.currentVariant?.price_cents, 10);
      if (Number.isFinite(variantCents) && variantCents >= 0) return variantCents;

      const selectedVariant = this.querySelector(`#SelectedVariant-${this.dataset.section}`);
      const selectedVariantCents = parseInt(selectedVariant?.dataset?.priceCents, 10);
      if (Number.isFinite(selectedVariantCents) && selectedVariantCents >= 0) return selectedVariantCents;

      const submitButton = document.querySelector(`#product-form-${this.dataset.section} .single-add-to-cart-button`);
      const submitButtonCents = parseInt(submitButton?.dataset?.unitPriceCents, 10);
      if (Number.isFinite(submitButtonCents) && submitButtonCents >= 0) return submitButtonCents;

      return null;
    }

    normalizePriceContainers() {
      const currentCents = this.getCurrentPriceCents();
      if (currentCents === null) return;

      const formatted = this.formatMoneyNoCurrency(currentCents);
      if (!formatted) return;

      const containers = [
        document.getElementById(`price-${this.dataset.section}`),
        document.getElementById(`price-${this.dataset.section}--sticky`)
      ].filter(Boolean);

      containers.forEach((container) => {
        if (container.querySelector('[data-sticky-total-price]')) {
          return;
        }

        const expectedMarkup = this.expectedPriceMarkup?.[container.id];
        if (typeof expectedMarkup === 'string' && expectedMarkup.length && container.innerHTML !== expectedMarkup) {
          container.innerHTML = expectedMarkup;
        }

        const isStableMarkup = container.dataset.priceLock === 'stable';
        if (isStableMarkup) {
          const stableValue = container.querySelector('.product-price-stable__value');
          if (stableValue && stableValue.textContent !== formatted) {
            stableValue.textContent = formatted;
          }
          return;
        }

        let priceElement = container.querySelector('.price');
        if (!priceElement) {
          container.innerHTML = '<span class="price"><ins><span class="amount"></span></ins></span>';
          priceElement = container.querySelector('.price');
        }

        let amount = priceElement.querySelector('ins .amount, .amount');
        if (!amount) {
          const ins = document.createElement('ins');
          amount = document.createElement('span');
          amount.className = 'amount';
          ins.appendChild(amount);
          priceElement.appendChild(ins);
        }

        if (amount.textContent !== formatted) {
          amount.textContent = formatted;
        }
      });
    }

    startPriceFormatGuard() {
      if (this.sticky || this.priceFormatGuardInterval) return;
      this.priceFormatGuardInterval = window.setInterval(() => {
        this.normalizePriceContainers();
      }, 350);
    }

    setupPriceFormatLock() {
      if (this.sticky) return;
      this.cacheExpectedPriceMarkup();
      this.normalizePriceContainers();
      this.startPriceFormatGuard();

      if (this.priceLockObserver) return;

      this.priceLockObserver = new MutationObserver(() => {
        this.scheduleNormalizePrices();
      });

      const mainPrice = document.getElementById(`price-${this.dataset.section}`);
      const stickyPrice = document.getElementById(`price-${this.dataset.section}--sticky`);

      if (mainPrice) {
        this.priceLockObserver.observe(mainPrice, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      if (stickyPrice) {
        this.priceLockObserver.observe(stickyPrice, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      if (document.body) {
        this.priceLockObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(mediaId);

      if (this.thumbnails) {
        this.setActiveMediaSlider(mediaId, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider);
      } else {
        this.setActiveMedia(activeMedia);
      }

    }
    setActiveMedia(activeMedia) {

      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      if (!this.sticky) {
        window.setTimeout(() => {
          if (window.innerWidth > 1068) {
            let header_h = activeMedia.parentElement.offsetTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')),
              scroll_obj = {
                left: 0,
                behavior: 'instant'
              };

            if (header_h > 0) {
              scroll_obj.top = header_h;
            }
            window.scrollTo(scroll_obj);
          }
          activeMedia.parentElement.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        });
      }
    }
    setActiveMediaSlider(mediaId, thumbId, productSlider) {
      let flkty = productSlider.flkty,
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (this.thumbnails) {
          let activeThumb = this.thumbnails.querySelector(thumbId);

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    getSelectedValueIds() {
      return this.fieldsets.map((fieldset) => {
        if (fieldset.querySelector('select')) {
          return fieldset.querySelector('select').selectedOptions[0]?.dataset.valueId;
        }
        return fieldset.querySelector('input:checked')?.dataset.valueId;
      }).filter(Boolean);
    }

    renderVariantInfo() {
      const ids = this.getSelectedValueIds();
      if (!ids.length) return;

      const scrollY = window.scrollY;

      fetch(`${this.dataset.url}?option_values=${ids.join(',')}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          // 1. Resolve variant from hidden span
          const span = html.getElementById(`SelectedVariant-${this.dataset.section}`);
          if (span && parseInt(span.dataset.variantId, 10)) {
            this.currentVariant = {
              id: parseInt(span.dataset.variantId, 10),
              available: span.dataset.available === 'true',
              featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null,
              price_formatted: span.dataset.priceFormatted || '',
              price_cents: parseInt(span.dataset.priceCents, 10) || 0
            };
          } else {
            this.currentVariant = null;
          }

          // 2. Sync data-available onto current DOM inputs (drives setDisabled)
          const sourceSelects = html.getElementById(`variant-selects-${this.dataset.section}`);
          if (sourceSelects) {
            sourceSelects.querySelectorAll('[data-value-id]').forEach((sourceEl) => {
              const vid = sourceEl.dataset.valueId;
              const avail = sourceEl.dataset.available;
              [this, ...this.other].forEach((el) => {
                const localEl = el.querySelector(`[data-value-id="${vid}"]`);
                if (localEl) localEl.dataset.available = avail;
              });
            });
          }

          // 3. Update price, inventory, sku sections
          this.getSectionsToRender().forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              if (id.includes('price')) {
                this.expectedPriceMarkup[id] = source.innerHTML;
              }
            }
            if (id.includes('price') && destination) destination.classList.remove('visibility-hidden');
          });
          this.scheduleNormalizePrices();

          // 4. Apply updated state
          if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
            window.scrollTo({ top: scrollY, behavior: 'instant' });
            return;
          }
          this.setDisabled();
          this.updateVariantInput();
          if (this.updateUrl) this.updateURL();
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
          this.updateMedia();
          window.scrollTo({ top: scrollY, behavior: 'instant' });
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          const variantPrice = this.currentVariant?.price_formatted ? ` | ${this.currentVariant.price_formatted}` : '';
          submitButton.dataset.unitPriceCents = this.currentVariant?.price_cents || 0;
          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = `${window.theme.variantStrings.preOrder}${variantPrice}`;
          } else {
            submitButtonText.textContent = `${window.theme.variantStrings.addToCart}${variantPrice}`;
          }
        }
      });

      const quantityInput = document.querySelector(`#product-form-${this.dataset.section} input[name="quantity"]`);
      if (quantityInput) {
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') return;

      this.fieldsets.forEach((fieldset) => {
        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option').forEach((opt) => {
            opt.disabled = opt.dataset.available === 'false';
          });
        } else {
          fieldset.querySelectorAll('input').forEach((input) => {
            input.classList.toggle('is-disabled', input.dataset.available === 'false');
          });
        }
      });
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }

    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      const optionPosition = parseInt(this.imageSetIndex.replace('option', ''), 10) - 1;
      let setValue = this.getImageSetName(this.options[optionPosition]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this));
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      if (!this.form) return;
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';

      if (!this.sticky) {
        this.onAreaInputChange = this.handleAreaInputChange.bind(this);
        this.onAreaControlsClick = this.handleAreaControlsClick.bind(this);
        this.onVariantChange = this.handleVariantChange.bind(this);
        this.form.addEventListener('input', this.onAreaInputChange);
        this.form.addEventListener('change', this.onAreaInputChange);
        this.form.addEventListener('click', this.onAreaControlsClick);
        document.documentElement.addEventListener('product:variant-change', this.onVariantChange);
      }
      this.syncWidthControlsFromVariantPicker();
      this.updateAddToCartButtonPrice();
    }
    disconnectedCallback() {
      if (this.onVariantChange) {
        document.documentElement.removeEventListener('product:variant-change', this.onVariantChange);
      }
    }
    formatMoney(cents) {
      const format = window.theme?.settings?.money_format || "${{amount}}";
      if (typeof formatMoney === 'function') {
        return formatMoney(cents, format);
      }
      return '';
    }
    parseWidthNumber(value) {
      const width = parseFloat(String(value || '').replace(/ft/ig, '').trim());
      return Number.isFinite(width) && width > 0 ? width : null;
    }
    getSelectedWidthFromVariantPicker() {
      const variantSelects = document.getElementById(`variant-selects-${this.dataset.section}`);
      if (!variantSelects) return null;
      const widthFieldset = Array.from(variantSelects.querySelectorAll('fieldset')).find((fieldset) => {
        const handle = (fieldset.dataset.handle || '').toLowerCase();
        return handle.includes('width');
      });
      if (!widthFieldset) return null;

      const select = widthFieldset.querySelector('select');
      if (select) return this.parseWidthNumber(select.value);

      const checked = widthFieldset.querySelector('input:checked');
      if (checked) return this.parseWidthNumber(checked.value);

      return null;
    }
    isWidthFixedByProduct() {
      const variantSelects = document.getElementById(`variant-selects-${this.dataset.section}`);
      if (!variantSelects) return true;
      const widthFieldset = Array.from(variantSelects.querySelectorAll('fieldset')).find((fieldset) => {
        const handle = (fieldset.dataset.handle || '').toLowerCase();
        return handle.includes('width');
      });
      if (!widthFieldset) return true;

      const select = widthFieldset.querySelector('select');
      if (select) return select.options.length <= 1;

      const options = widthFieldset.querySelectorAll('input[type="radio"], input[type="checkbox"]');
      return options.length <= 1;
    }
    getFixedWidthValue() {
      const selectedWidth = this.getSelectedWidthFromVariantPicker();
      if (selectedWidth !== null) return selectedWidth;

      const width = parseFloat(this.dataset.fixedWidthFt);
      return Number.isFinite(width) && width > 0 ? width : 15;
    }
    handleVariantChange(event) {
      const sectionId = event?.detail?.sectionId;
      if (String(sectionId) !== String(this.dataset.section)) return;
      this.syncWidthControlsFromVariantPicker();
      this.updateAddToCartButtonPrice();
    }
    getLengthInput() {
      return this.form.querySelector('[data-length-input]');
    }
    getLengthOptionButtons() {
      return this.form.querySelectorAll('[data-length-option]');
    }
    getWidthOptionButtons() {
      return this.form.querySelectorAll('[data-width-option]');
    }
    getCustomLengthTrigger() {
      return this.form.querySelector('[data-length-custom-trigger]');
    }
    getQuantityInput() {
      return this.form.querySelector('input[name="quantity"]');
    }
    getDisplayQuantityInput() {
      return this.form.querySelector('[data-display-quantity-input]');
    }
    getWasteCheckbox() {
      return this.form.querySelector('[data-waste-checkbox]');
    }
    getBackyardCheckbox() {
      return this.form.querySelector('[data-backyard-checkbox]');
    }
    getBackyardNote() {
      return this.form.querySelector('[data-backyard-note]');
    }
    isWasteAllowanceEnabled() {
      return Boolean(this.getWasteCheckbox()?.checked);
    }
    isBackyardDeliveryEnabled() {
      return Boolean(this.getBackyardCheckbox()?.checked);
    }
    syncBackyardMessageVisibility() {
      const backyardNote = this.getBackyardNote();
      if (!backyardNote) return;
      backyardNote.hidden = !this.isBackyardDeliveryEnabled();
    }
    getLengthValue() {
      const lengthInput = this.getLengthInput();
      const length = parseInt(lengthInput?.value, 10);
      return Number.isFinite(length) && length > 0 ? length : 1;
    }
    getDisplayQuantityValue() {
      const displayQuantityInput = this.getDisplayQuantityInput();
      const quantity = parseInt(displayQuantityInput?.value, 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }
    syncWidthControlsFromVariantPicker() {
      const width = this.getSelectedWidthFromVariantPicker();
      if (width === null) return;
      this.getWidthOptionButtons().forEach((button) => {
        const buttonWidth = this.parseWidthNumber(button.dataset.widthOption);
        button.classList.toggle('is-active', buttonWidth === width);
      });
      const widthDisplayEl = this.form.querySelector('[data-width-display]');
      if (widthDisplayEl) {
        widthDisplayEl.textContent = width;
      }
    }
    applyWidthToVariantSelectors(widthValue) {
      const normalizedWidth = String(widthValue);
      const selectors = [
        document.getElementById(`variant-selects-${this.dataset.section}`),
        document.getElementById(`variant-selects-${this.dataset.section}--sticky`)
      ].filter(Boolean);

      selectors.forEach((selector) => {
        const widthFieldset = Array.from(selector.querySelectorAll('fieldset')).find((fieldset) => {
          const handle = (fieldset.dataset.handle || '').toLowerCase();
          return handle.includes('width');
        });
        if (!widthFieldset) return;

        const select = widthFieldset.querySelector('select');
        if (select) {
          if (select.value === normalizedWidth) return;
          select.value = normalizedWidth;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        const optionInput = widthFieldset.querySelector(`input[value="${normalizedWidth}"]`);
        if (!optionInput || optionInput.checked) return;
        optionInput.checked = true;
        optionInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    setPresetLength(length) {
      const lengthInput = this.getLengthInput();
      if (!lengthInput) return;
      lengthInput.value = length;
      lengthInput.readOnly = true;

      this.getLengthOptionButtons().forEach((button) => {
        button.classList.toggle('is-active', parseInt(button.dataset.lengthOption, 10) === length);
      });
      const customTrigger = this.getCustomLengthTrigger();
      if (customTrigger) customTrigger.classList.remove('is-active');
    }
    setCustomLengthMode(shouldFocus = false) {
      const lengthInput = this.getLengthInput();
      if (!lengthInput) return;
      lengthInput.readOnly = false;

      this.getLengthOptionButtons().forEach((button) => {
        button.classList.remove('is-active');
      });
      const customTrigger = this.getCustomLengthTrigger();
      if (customTrigger) customTrigger.classList.add('is-active');
      if (shouldFocus) {
        lengthInput.focus();
      }
    }
    syncLengthModeFromValue() {
      const length = this.getLengthValue();
      const presetMatch = [10, 20, 30].includes(length);
      if (presetMatch) {
        this.setPresetLength(length);
      } else {
        this.setCustomLengthMode(false);
      }
    }
    handleAreaControlsClick(event) {
      const widthButton = event.target.closest('[data-width-option]');
      if (widthButton) {
        event.preventDefault();
        const widthValue = this.parseWidthNumber(widthButton.dataset.widthOption);
        if (widthValue !== null) {
          this.applyWidthToVariantSelectors(widthValue);
          this.syncWidthControlsFromVariantPicker();
          this.updateAddToCartButtonPrice();
        }
        return;
      }

      const presetButton = event.target.closest('[data-length-option]');
      if (presetButton) {
        event.preventDefault();
        const length = parseInt(presetButton.dataset.lengthOption, 10);
        if (Number.isFinite(length) && length > 0) {
          this.setPresetLength(length);
          this.updateAddToCartButtonPrice();
        }
        return;
      }

      const customButton = event.target.closest('[data-length-custom-trigger]');
      if (customButton) {
        if (event.target.matches('[data-length-input]')) return;
        this.setCustomLengthMode(true);
      }
    }
    getSquareFootageValue() {
      return this.getAreaPayload().totalSqft;
    }
    getAreaPayload() {
      const width = this.getFixedWidthValue();
      const length = this.getLengthValue();
      const pieces = this.getDisplayQuantityValue();
      const pieceSqft = Math.max(1, Math.round(width * length));
      const baseTotalSqft = Math.max(1, pieceSqft * pieces);
      const includeWasteAllowance = this.isWasteAllowanceEnabled();
      const totalSqft = includeWasteAllowance ? Math.max(1, Math.ceil(baseTotalSqft * 1.1)) : baseTotalSqft;

      return {
        width,
        length,
        pieces,
        pieceSqft,
        baseTotalSqft,
        totalSqft,
        includeWasteAllowance
      };
    }
    syncAreaFields() {
      const area = this.getAreaPayload();
      const sqft = area.totalSqft;
      const quantityInput = this.getQuantityInput();
      const totalSqftElements = this.form.querySelectorAll('[data-total-sqft]');
      const widthProperty = this.form.querySelector('[data-width-property]');
      const totalAreaProperty = this.form.querySelector('[data-total-area-property]');
      const wasteProperty = this.form.querySelector('[data-waste-property]');

      if (quantityInput) {
        quantityInput.value = sqft;
      }
      totalSqftElements.forEach((element) => {
        element.textContent = sqft;
      });
      if (widthProperty) {
        widthProperty.value = `${area.width}ft`;
      }
      if (totalAreaProperty) {
        totalAreaProperty.value = `${sqft} sqft`;
      }
      if (wasteProperty) {
        wasteProperty.value = area.includeWasteAllowance ? 'Yes' : 'No';
      }
      const sizePerPieceEl = this.form.querySelector('[data-size-per-piece]');
      const totalAreaEl = this.form.querySelector('[data-total-area]');
      const widthDisplayEl = this.form.querySelector('[data-width-display]');
      const widthFixedNoteEl = this.form.querySelector('[data-width-fixed-note]');
      if (sizePerPieceEl) {
        sizePerPieceEl.textContent = `${area.width} ft × ${area.length} ft = ${area.pieceSqft} sqft`;
      }
      if (widthDisplayEl) {
        widthDisplayEl.textContent = area.width;
      }
      if (widthFixedNoteEl) {
        widthFixedNoteEl.style.display = this.isWidthFixedByProduct() ? '' : 'none';
      }
      if (totalAreaEl) {
        totalAreaEl.textContent = area.includeWasteAllowance ? `${sqft} sqft (incl. 10% waste)` : `${sqft} sqft`;
      }
      this.syncBackyardMessageVisibility();
      return sqft;
    }
    handleAreaInputChange(event) {
      if (!event.target.matches('input[name="quantity"], [data-length-input], [data-display-quantity-input], [data-waste-checkbox], [data-backyard-checkbox]')) return;
      if (event.target.matches('[data-length-input]') && !event.target.readOnly) {
        this.syncLengthModeFromValue();
      }
      this.updateAddToCartButtonPrice();
    }
    updateAddToCartButtonPrice() {
      if (!this.getLengthInput()) return;
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      if (!submitButtons.length) return;

      const quantity = this.syncAreaFields();
      const isPreOrder = (this.getAttribute('template') || '').includes('pre-order');
      const baseLabel = isPreOrder ? window.theme.variantStrings.preOrder : window.theme.variantStrings.addToCart;

      submitButtons.forEach((submitButton) => {
        if (submitButton.disabled || submitButton.classList.contains('sold-out')) return;

        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButtonText) return;

        const unitPriceCents = parseInt(submitButton.dataset.unitPriceCents, 10) || 0;
        if (unitPriceCents > 0) {
          const totalPrice = this.formatMoney(unitPriceCents * quantity);
          submitButtonText.textContent = `${baseLabel} | ${totalPrice}`;

          const totalPriceEl = this.form.querySelector('[data-total-price]');
          if (totalPriceEl) {
            totalPriceEl.textContent = totalPrice;
          }

          const stickyPriceEl = document.querySelector(`#price-${this.dataset.section}--sticky [data-sticky-total-price]`);
          if (stickyPriceEl) {
            stickyPriceEl.textContent = totalPrice;
          }
        } else {
          submitButtonText.textContent = baseLabel;
        }
      });
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      const area = this.getAreaPayload();
      this.syncAreaFields();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);
      // Ensure cart payload always matches calculator state.
      formData.set('quantity', String(area.totalSqft));
      formData.set('properties[Width]', `${area.width}ft`);
      formData.set('properties[Select Length]', String(area.length));
      formData.set('properties[Quantity]', String(area.pieces));
      formData.set('properties[Total area]', `${area.totalSqft} sqft`);
      formData.set('properties[Add 10% for cuts & waste]', area.includeWasteAllowance ? 'Yes' : 'No');
      if (this.isBackyardDeliveryEnabled()) {
        formData.set('properties[Backyard Delivery]', 'Yes');
      } else {
        formData.delete('properties[Backyard Delivery]');
      }
      // Prevent preorder app metadata from polluting cart line-item properties.
      formData.delete('properties[Availability date]');
      formData.delete('properties[Payment]');
      formData.delete('properties[Preorder]');
      formData.delete('properties[Pre-order]');

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      const product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        document.body.classList.remove('open-cc--product');
        product_drawer.classList.remove('active');
        product_drawer.setAttribute('inert', '');
      }
      document.getElementById('Cart-Drawer')?.open();
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
      this.setupObservers();
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}
